// src/utils/coreService.js

import { CORE_SERVICE_BASE_URL } from "@/constants/app";
import axios from "axios";
import { store } from "@/store/store";
import { deleteAccessToken } from "@/store/user";
// Create an Axios instance
const SELLER_ACCOUNT_TOKEN =
  "eyJ0eXAiOiJKV1QiLCJub25jZSI6Imt1UldMd0YtaUFFYnUxQ1pFRjV4Z01TdWpVdjhNbk85RmFBZ0pYbU1JMUEiLCJhbGciOiJSUzI1NiIsIng1dCI6IlBjWDk4R1g0MjBUMVg2c0JEa3poUW1xZ3dNVSIsImtpZCI6IlBjWDk4R1g0MjBUMVg2c0JEa3poUW1xZ3dNVSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC82YmZjYzNiNS03YjQ4LTRkM2EtODFkZi1hNjQwYzQ5ZjhkMzEvIiwiaWF0IjoxNzY3ODcyOTUyLCJuYmYiOjE3Njc4NzI5NTIsImV4cCI6MTc2Nzg3NzAxMywiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicDEiXSwiYWlvIjoiQVpRQWEvOGFBQUFBWTFOT0x1elpmVjFRT1FCVWNqb1kvdEJDVmpMd3VCY0JIdDVMcHAwdmt6TXJ6amljV1NpV1NBK1hhdWliZm1EblRTWVl0S3ZTdFl6aVlPbjUrdGwvWW8zTGNFTzVzTHZOT3JCazhocUdFS1J1YzErTUh5MDRUUjNLWjhEQWRJMnBQZTRzcXhvZzZZNCs0WUp0RWVEY2xhOWxFUjdHbjlLbXdrdkhHT04rTUlHakkrMkpmbE41RFBUR05XL1B4ZkJYIiwiYW1yIjpbInB3ZCIsIm1mYSJdLCJhcHBfZGlzcGxheW5hbWUiOiJSZWZsb3cgQ29ubmVjdCIsImFwcGlkIjoiMDliYTM5YzAtZTA2Yi00YjcyLWExNDYtOTBjYTczYmZiNzAwIiwiYXBwaWRhY3IiOiIxIiwiZmFtaWx5X25hbWUiOiJVemFpciIsImdpdmVuX25hbWUiOiJTaGVpa2giLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxOC4xNTkuMTkuMTUzIiwibmFtZSI6IlNoZWlraCBVemFpciIsIm9pZCI6IjlkZDM2OWM5LTgzMGYtNDY5YS05Y2E5LTRiOWM0OGY4YjJkNyIsInBsYXRmIjoiMyIsInB1aWQiOiIxMDAzMjAwNDczRTJFMEI4IiwicmgiOiIxLkFTQUF0Y1A4YTBoN09rMkIzNlpBeEotTk1RTUFBQUFBQUFBQXdBQUFBQUFBQUFEa0FHVWdBQS4iLCJzY3AiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsInNpZCI6IjAwYWEwMzg5LWM2YjctZGUzOS02ZGRkLTM5NmZlNTM4MzQyZiIsInNpZ25pbl9zdGF0ZSI6WyJrbXNpIl0sInN1YiI6IlpLV01Scm5RVmVrVTR3REtJaUc1MTVqMWVDU19MUTMyYW1ZNnZaTTRRSDgiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiRVUiLCJ0aWQiOiI2YmZjYzNiNS03YjQ4LTRkM2EtODFkZi1hNjQwYzQ5ZjhkMzEiLCJ1bmlxdWVfbmFtZSI6InNoZWlraC51emFpckBpLXdheXMubmV0IiwidXBuIjoic2hlaWtoLnV6YWlyQGktd2F5cy5uZXQiLCJ1dGkiOiIwSEF1WHJpTVIweURyMkUwa0UwSkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX2FjZCI6MTc1NTUxNTI2NiwieG1zX2FjdF9mY3QiOiIzIDkiLCJ4bXNfZnRkIjoiZjZzMDlpUTJwSFJ4cWZRbmFfeVdGRlJYTUtmbUYxUC1LaUdvUDFaUW9uWUJjM2RsWkdWdVl5MWtjMjF6IiwieG1zX2lkcmVsIjoiMTAgMSIsInhtc19zdCI6eyJzdWIiOiJFMjctdWs2azFzbnl5a0FWcHU3Rkx3M3N0WWFLc25Ra3JScWp2SzBnSGx3In0sInhtc19zdWJfZmN0IjoiMTQgMyIsInhtc190Y2R0IjoxNDUzMTIwMzQ0LCJ4bXNfdGRiciI6IkVVIiwieG1zX3RudF9mY3QiOiIzIDIifQ.RoyCVMgBba0vrFF5jhtKBIPwpFXoJX2G3KlD_yVr7UYc6pQ1ZXEF2wAKMPRd42bQZYdOMKHyHqQoSGZhSBw38uol8q0TEjTtPZvE3kPxzVNKAL__Y8sQQ1n6-5z6lv3pazIttTyAZFZZi6Q3rc0D0KqTsHPfRx29s66l2x1g9acOq7UNWA80TQ0GRdKjzLYWc-Tdwf7QXw_yGrscnyk2sIpoWdiv2UsiNEH1OyuSFmrP6gL8Wf74-utmdBecU0XxbllZS425dkIl7J-3WCkjr9077tXsi6O5lNljKR0VDgB0L8EogrbmfMnxAiwgz-NelVEpHcAKe98yyy148epwEQ";
const coreService = axios.create({
  baseURL: CORE_SERVICE_BASE_URL, // Base URL for your API
  timeout: 20000, // Request timeout (optional)
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the Authorization header
coreService.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      // Check if the window object is available
      const token = store.getState().user?.accessToken;
      const securityGroup = store.getState().user?.selectedSecurityGroup;
      const isSuperUser = store.getState().user?.loginData?.superUser;
      // const token = SELLER_ACCOUNT_TOKEN;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["is-Super-Admin"] = String(isSuperUser ?? false);
      }
      if (securityGroup) {
        config.headers["X-Security-Group-Id"] = securityGroup.securityGroup;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Add a response interceptor to handle responses and errors
coreService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors globally here if needed
    if (error.response && error.response.status === 401) {
      // Redirect to login or handle unauthorized access
      console.error("Unauthenticated! Redirecting to login...");
      const isSuperUser = store.getState().user?.loginData?.superUser;
      store.dispatch(deleteAccessToken());
      const redirectTo = isSuperUser ? "/de/s-admin/login" : "/de/login"; 
      window.location.href = redirectTo;
    } else if (error.response && error.response.status === 403) {
      // Redirect to login or handle unauthorized access
      console.error("Unauthorized! Redirecting to 403...");

      // window.location.href = "/403";
    }

    return Promise.reject(error);
  }
);
export default coreService;
